let ScrollSpy = require('../modules/ScrollSpy');
let Scroll    = require('../components/Scroll');

class Menu {
    constructor(className = '') {
        this._menu      = document.getElementsByClassName('js-menu')[0];
        this._links     = className !== '' ? this._menu.getElementsByClassName(className) : [];
        this._scrollSpy = null;
        this._main      = document.querySelector('main');
        this._burger    = document.getElementById('toggle-mobile-nav');

        this._secondMenu = [];

        this._links = Array.from(this._links);

        for (let link of this._links) {
            if (!link.hasAttribute('href')) {
                this._secondMenu.push(link);
                let index = this._links.indexOf(link);
                this._links.splice(index, 1);
            }
        }
    }

    init(mobileListener = false) {
        this._scrollSpy = new ScrollSpy(this._links, this._menu.getBoundingClientRect().height + window.innerHeight / 10);
        if (mobileListener) {
            this._subMenuOpen = null;
            this._burger.addEventListener('click', this._toggleMobile, true);

            for (let link of this._secondMenu) {
                link.addEventListener('click', () => {
                    let isOpen = link.classList.toggle('open');
                    if (isOpen) {
                        this._subMenuOpen = link;
                    } else {
                        this._subMenuOpen = null;
                    }
                });
            }

            document.getElementsByTagName('main')[0].addEventListener('click', () => {
                if (this._subMenuOpen !== null) {
                    this._subMenuOpen.classList.remove('open');
                    this._subMenuOpen = null;
                }
            });
        }
        this._scroll();
    }

    _scroll() {
        for (let link of this._links) {
            let attribute = link.hasAttribute('href') ? 'href' : 'data-target';
            link.addEventListener('click', (e) => {
                e.preventDefault();

                if (this._subMenuOpen !== undefined && this._subMenuOpen !== null) {
                    this._subMenuOpen.classList.remove('open');
                    this._subMenuOpen = null;
                }

                let targetTop = document.querySelector(link.getAttribute(attribute) + '').offsetTop;

                if (window.innerWidth <= 1024) {
                    targetTop -= 40;
                }

                new Scroll().to(targetTop);
            });
        }
    }

    getLinks() {
        return this._links;
    }

    _toggleMobile = () => {
        if (this._burger.classList.contains('active')) {
            this._burger.classList.remove('active');
            this._main.classList.remove('popup-open');
            document.removeEventListener('click', this._clickMenuOpen, true);
        } else {
            this._burger.classList.add('active');
            this._main.classList.add('popup-open');
            document.addEventListener('click', this._clickMenuOpen, true);
        }
    };

    _clickMenuOpen = (e) => {
        if ((e.target.tagName === 'A' && !e.target.classList.contains('active')) || (e.target.closest('header') === null)) {
            this._toggleMobile();
        }
    };
}

module.exports = Menu;
